module.exports = __webpack_public_path__ + "img/bbva.321691d5.svg";